<template>
  <div class="user-page">
    <div class="table-toolbar">
      <el-row :gutter="15">
        <el-col :span="12">
          <div class="table-toolbar-left">   
            <el-form :inline="true" size="small">
              <el-form-item>
                <el-input @keyup.enter.native="getUsersList()" v-model="query.search" placeholder="请输入公司名称或邮箱"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getUsersList()">搜索</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="table-toolbar-right">
            <el-button v-if="disabled1" type="primary" @click="addUser()" size="small">新增用户</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="tablebox">
      <el-table v-loading="loading" :data="tablelist" tooltip-effect="dark" size="small" :cell-style="getTableCellStyle">
        <el-table-column prop='userId' label="ID" width="60"></el-table-column>
        <el-table-column prop='email' label="用户邮箱" width="300" show-overflow-tooltip></el-table-column>
        <el-table-column prop='company' label="公司名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop='phone' label="手机号" width="120"></el-table-column>
        <el-table-column prop='isagency' label="是否代理" width="120"></el-table-column>
        <el-table-column label="定制报告" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.url === 'none' || scope.row.url === ''">无</span>
            <a v-if="scope.row.url !== 'none' && scope.row.url !== ''" :href="scope.row.url" target="_blank">查看</a>
          </template>
        </el-table-column>
        <el-table-column prop='createdAt' label="注册时间" width="100"></el-table-column>
        <el-table-column prop='loginTime' label="最近登录" width="130"></el-table-column>
        <el-table-column v-if="disabled1" label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="editUser(scope.row)">修改</el-button>
            <el-button v-if="scope.row.status === 'active'" type="warning" size="mini" @click="suspendUser(scope.row.userId, 0)">暂停</el-button>
            <el-button v-if="scope.row.status === 'pending'" type="success" size="mini" @click="suspendUser(scope.row.userId, 1)">启用</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="table-pagination">
      <el-pagination
        small
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        popper-class="pagesizeclass"
        :page-sizes="[25, 50, 100]"
        :page-size="query.size"
        layout="total, prev, pager, next, sizes"
        :total="totalusers">
      </el-pagination>      
    </div>

    <el-dialog
      title="修改用户"
      custom-class="editdialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="editUserDialog"
      width="700px">
      <div class="edit-form">
        <el-form :model="editform" :rules="adduserform" ref="edituserform" label-width="80px" size="small">
          <el-form-item label="用户名" prop="username">
            <el-col :span="12">
              <el-input v-model="editform.username"></el-input>
            </el-col>
            <el-col :span="12">
              <p>用户名5-25字符</p>
            </el-col>
          </el-form-item>
          <el-form-item label="代理商" prop="role">
            <el-col :span="12">
              <el-checkbox :disabled="isadmin" v-model="isagency">代理商<span v-if="isadmin">（该账户是管理员权限）</span></el-checkbox>
            </el-col>
            <el-col :span="12">
              <p>将该用户设为代理商身份</p>
            </el-col>
          </el-form-item>
          <el-form-item label="买手" prop="testbuyer">
            <el-col :span="12">
              <el-checkbox :disabled="isadmin" v-model="istestbuyer" @change="settestbuyercompany">买手<span v-if="isadmin">（该账户是管理员权限）</span></el-checkbox>
            </el-col>
            <el-col :span="12">
              <p>将该用户设为买手身份</p>
            </el-col>
          </el-form-item>
          <el-form-item label="Logo地址" v-if="isagency">
            <el-col :span="12">
              <el-input v-model="editform.imgurl"></el-input>
            </el-col>
            <el-col :span="12">
              <p>请输入合作伙伴Logo地址，格式：email.png</p>
            </el-col>
          </el-form-item>
          <el-form-item label="公司名称" prop="company">
            <el-col :span="12">
              <el-input v-model="editform.company"></el-input>
            </el-col>
            <el-col :span="12">
              <p>请输入公司名称</p>
            </el-col>
          </el-form-item>
          <el-form-item label="邮箱">
            <el-col :span="12">
              <el-input :disabled="true" v-model="editform.email"></el-input>
            </el-col>
            <el-col :span="12">
            </el-col>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-col :span="12">
              <el-input v-model="editform.phone"></el-input>
            </el-col>
            <el-col :span="12">
            </el-col>
          </el-form-item>
          <el-form-item label="定制报告" prop="url" v-if="false">
            <el-col :span="12">
              <el-input v-model="editform.url"></el-input>
            </el-col>
            <el-col :span="12">
              <p>请输入定制报告URL地址</p>
            </el-col>
          </el-form-item>
          <el-form-item label="密码">
            <el-col :span="12">
              <el-input :disabled="true" placeholder="如需修改请点击右侧按钮"></el-input>
            </el-col>
            <el-col :span="12">
              <el-button type="primary" @click="changePassword()" size="small">修改密码</el-button>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editUserDialog = false" size="small">取 消</el-button>
        <el-button type="primary" @click="confirmEditUser('edituserform')" size="small">确 定</el-button>
      </span>
      <el-dialog
        custom-class="editdialog"
        width="300px"
        title="修改密码"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :visible.sync="changepassworddialog"
        append-to-body>
        <div class="edit-form">
          <el-form :model="addform" size="small" :rules="adduserform" ref="changeuserpasswd" >
            <el-form-item prop="newpassword">
              <el-input v-model="newpassword" placeholder="请输入新密码"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="changepassworddialog = false; newpassword = ''" size="small">取 消</el-button>
          <el-button type="primary" @click="confirmChangePassword(editform.userid, 'changeuserpasswd')" size="small">确 定</el-button>
        </span>
      </el-dialog>
    </el-dialog>

    <el-dialog
      title="新增用户"
      custom-class="editdialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="addUserDialog"
      width="700px">
      <div class="edit-form">
        <el-form :model="addform" :rules="adduserform" ref="adduserform" label-width="80px" size="small">
          <el-form-item label="用户名" prop="username">
            <el-col :span="12">
              <el-input v-model="addform.username"></el-input>
            </el-col>
            <el-col :span="12">
              <p>用户名5-25字符</p>
            </el-col>
          </el-form-item>
          <el-form-item label="代理商" prop="role">
            <el-col :span="12">
              <el-checkbox v-model="isagency">代理商</el-checkbox>
            </el-col>
            <el-col :span="12">
              <p>将该用户设为代理商身份</p>
            </el-col>
          </el-form-item>
          <el-form-item label="买手" prop="testbuyer">
            <el-col :span="12">
              <el-checkbox :disabled="isadmin" v-model="istestbuyer" @change="settestbuyercompany">买手<span v-if="isadmin">（该账户是管理员权限）</span></el-checkbox>
            </el-col>
            <el-col :span="12">
              <p>将该用户设为买手身份</p>
            </el-col>
          </el-form-item>
          <el-form-item label="公司名称" prop="company">
            <el-col :span="12">
              <el-input v-model="addform.company"></el-input>
            </el-col>
            <el-col :span="12">
              <p>请输入公司名称</p>
            </el-col>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-col :span="12">
              <el-input v-model="addform.email"></el-input>
            </el-col>
            <el-col :span="12">
            </el-col>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-col :span="12">
              <el-input v-model="addform.phone"></el-input>
            </el-col>
            <el-col :span="12">
            </el-col>
          </el-form-item>
          <el-form-item label="定制报告" prop="url">
            <el-col :span="12">
              <el-input v-model="addform.url"></el-input>
            </el-col>
            <el-col :span="12">
              <p>请输入定制报告URL地址</p>
            </el-col>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-col :span="12">
              <el-input v-model="addform.password" show-password></el-input>
            </el-col>
            <el-col :span="12">
              <p>包含5-25个字符</p>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addUserDialog = false" size="small">取 消</el-button>
        <el-button type="primary" :disabled="disableaddbtn" @click="confirmAddtUser('adduserform')" size="small">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data(){
    let isUrl = (rule, value, callback) => {
      let matchUrl = /^(https?:\/\/(([a-zA-Z0-9]+-?)+[a-zA-Z0-9]+\.)+[a-zA-Z]+)(:\d+)?(\/.*)?(\?.*)?(#.*)?$/
      if(value.trim().length<1){
        callback()
      }else{
        if (value.trim().length > 1000) {
          callback(new Error('不能超过1000个字符'))
          return
        } else {
          if (!matchUrl.test(value.trim())) {
            callback(new Error('不是正确网址'))
            return
          }else{
            callback()
          }
        }
      }
    }
    return{
      loading: false,
      query: {
        search: '',
        page: 1,
        size: this.getLocalStorage('pagesize9') ? this.getLocalStorage('pagesize9') * 1 : 25
      },
      currentPage: 1,
      tablelist: [],
      totalusers: 0,
      editUserDialog: false,
      addUserDialog: false,
      editform: {
        userid: '',
        username: '',
        company: '',
        email: '',
        imgurl: '',
        phone: '',
        url: '',
        role: ''
      },
      addform: {
        username: '',
        company: '',
        email: '',
        imgurl: '',
        phone: '',
        url: '',
        password: '',
        role: ''
      },
      isagency: false,
      istestbuyer: false,
      adduserform: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 2, max: 25, message: '长度在 2 到 25 个字符', trigger: 'blur' }
        ],
        company: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          // {
          //   pattern: /^0{0,1}(\+|13[0-9]|15[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/,
          //   message: '手机号格式不对',
          //   trigger: 'blur'
          // }
        ],
        url: [{ validator: isUrl, trigger: ['blur', 'change'] }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 5, max: 25, message: '长度在 5 到 25 个字符', trigger: 'blur' }
        ],
      },
      changeuserpasswd: {
        newpassword: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 5, max: 25, message: '长度在 5 到 25 个字符', trigger: 'blur' }
        ],        
      },
      changepassworddialog: false,
      newpassword: '',
      disableaddbtn: false,
      disabled1: this.getLocalStorage('level')/1 === 1 ? true : false,
      disabled3: this.getLocalStorage('level')/1 === 3 ? true : false,
      isadmin: false
    }
  },

  mounted(){
    this.getUsersList()
  },

  methods: {

    /**
     * 切换每页显示条目数
     */
    handleSizeChange(val) {
      let that = this
      that.currentPage = 1
      that.query.page = 1
      that.query.size = val
      that.setLocalStorage('pagesize9', val)
      that.getUsersList()
    },

    /**
     * 切换分页
     */
    handleCurrentChange(val) {
      let that = this
      that.query.page = val
      that.getUsersList()
    },

    /**
     * 获取用户列表
     */
    getUsersList: function(){
      let that = this
      let url = that.API_URL + '/sys/users/list'
      let query = that.query
      that.loading = true
      that.tablelist = []
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('getUsersList', data)
          that.totalusers = data.results[0][0].Count
          let lists = data.results[1]
          lists.forEach(function(res){
            //res.url = res.url === 'none' ? '' : res.url
            res.isagency = res.roleid/1 === 2 ? '是' : '否'
            res.istestbuyer = res.roleid/1 === 3 ? '是' : '否'
            res.isadmin = res.roleid/1 === 0 ? true : false
            res.createdAt = that.$moment(res.createdAt).utcOffset(960).format('YYYY-MM-DD')
            res.loginTime = res.loginTime === null ? '' : that.$moment(res.loginTime).utcOffset(960).format('YYYY-MM-DD HH:mm')
          })
          that.tablelist = lists
          that.loading = false
        },
        error: function(response) {
          console.log('getUsersList', response)
        }
      })
    },

    /**
     * 暂停用户
     */
    suspendUser: function(uid, status){
      let that = this
      let url = that.API_URL + '/sys/users/ban'
      let query = {
        userid: uid,
        status: status
      }
      $.ajax({
        url: url,
        type: "PUT",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('getUsersList', data)
          that.getUsersList()
        },
        error: function(response) {
          console.log('getUsersList', response)
        }
      })
    },

    /**
     * 修改用户弹窗
     */
    editUser: function(row){
      console.log(row)
      let that = this
      that.editform = {
        userid: row.userId,
        username: row.username,
        company: row.company,
        imgurl: row.imgurl,
        email: row.email,
        phone: row.phone,
        url: row.url,
        role: row.roleid
      }
      that.isagency = that.editform.role/1 === 2 ? true : false
      that.istestbuyer = that.editform.role/1 === 3 ? true : false
      that.isadmin = row.isadmin
      that.editUserDialog = true
    },

    /**
     * 新增用户
     */
    addUser: function(){
      let that = this
      that.addUserDialog = true
    },

    /**
     * 隐藏对话框
     */
    cancelDialog: function(){
      let that = this
      that.editform = {}
      that.editUserDialog = false
    },

    /**
     * 确认修改用户
     */
    confirmEditUser: function(refs){
      let that = this
      that.$refs[refs].validate(function(valid){
        if(valid){
          let url = that.API_URL + '/sys/users/edit'
          that.editform.role = that.isagency === true ? 2 : 1
          let query = {
            userid: that.editform.userid,
            username: that.editform.username,
            company: that.editform.company,
            phone: that.editform.phone,
            url: that.editform.url,
            role: that.isadmin === true && that.isagency === false ? 0 : that.istestbuyer == true ? 3 : that.editform.role,
            imgurl: that.editform.imgurl
          }
          $.ajax({
            url: url,
            type: "PUT",
            headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
            changeOrigin: true,
            crossDomain: true,
            data: query,
            success: function(data) {
              console.log('getUsersList', data)
              that.editUserDialog = false
              that.getUsersList()
            },
            error: function(response) {
              console.log('getUsersList', response)
            }
          })
        } else {
          return false
        }
      })
    },

    /**
     * 确认新增用户
     */
    confirmAddtUser: function(refs){
      let that = this
      that.$refs[refs].validate(function(valid){
        if (valid) {
          that.disableaddbtn = true
          that.checkEmail(that.addform.email, function(rs){
            if(rs){
              let url = that.API_URL + '/sys/users/add'
              that.addform.role = that.isagency === true ? 2 : that.istestbuyer === true ? 3: 1
              let query = that.addform
              $.ajax({
                url: url,
                type: "POST",
                headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
                changeOrigin: true,
                crossDomain: true,
                data: query,
                success: function(data) {
                  console.log('confirmAddtUser', data)
                  that.addUserDialog = false
                  that.addform = {
                    username: '',
                    company: '',
                    email: '',
                    phone: '',
                    url: '',
                    password: '',
                    role: '',
                    imgurl: ''
                  }
                  that.isagency = false
                  that.getUsersList()
                },
                error: function(response) {
                  console.log('confirmAddtUser', response)
                }
              })              
            }else{
              that.$message({
                offset: 80,
                message: "邮箱已经存在",
                type: 'error'
              })
              that.disableaddbtn = false
            }
          })
        } else {
          return false
        }
      })
    },

    /**
     * 修改密码
     */
    changePassword: function(){
      let that = this
      that.newpassword = ''
      that.changepassworddialog = true
    },

    /**
     * 确认修改密码
     */
    confirmChangePassword: function(uid, refs){
      let that = this
      that.$refs[refs].validate(function(valid){
        if(valid){
          let url = that.API_URL + '/sys/users/reset'
          let query = {
            userid: uid,
            password: that.newpassword
          }
          $.ajax({
            url: url,
            type: "PUT",
            headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
            changeOrigin: true,
            crossDomain: true,
            data: query,
            success: function(data) {
              console.log('getUsersList', data)
              that.changepassworddialog = false
            },
            error: function(response) {
              console.log('getUsersList', response)
            }
          })
        }else{
          return false
        }
      })
    },

    /**
     * 查找邮箱
     */
    checkEmail: function(email, callback){
      let that = this
      let url = that.API_URL + '/sys/users/check'
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: {email: email, type: 0},
        success: function(data) {
          console.log('checkEmail', data)
          let availableemail = data.results.length === 0 ? true : false
          callback(availableemail)
        },
        error: function(response) {
          console.log('checkEmail', response)
        }
      })
    },

    settestbuyercompany: function(val){
      if(val == true){
        this.addform.company = '买手'
      } else{
        this.addform.company = ''
      }
    },

  },

}
</script>